/**
 * row-location-date.js
 */

import React from 'react';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { format } from 'date-fns';


export const rowDateFormat = 'M/d/yyyy h:mm aa';


const useStyles = makeStyles(theme => ({
  locationDate: {
    [theme.breakpoints.down('sm')]: {
      '& .location': {
        order: 2
      },
      '& .separator': {
        order: 1
      },
      '& .date': {
        order: 0
      }
    }
  }
}));


export default (props) => {
  const {
    location,
    date
  } = props;
  const classes = useStyles();

  return (
    <div className={`location-date ${classes.locationDate}`}>
      {/* location */}
      <Typography
        variant='body2'
        className='ellipsis-overflow location'
        data-testtype='record-location'
      >
        {location}
      </Typography>

      {/* separator */}
      <Typography
        variant='body2'
        className='separator'
      >
        &nbsp;-&nbsp;
      </Typography>

      {/* date */}
      <Typography
        variant='body2'
        className='date'
        data-testtype='record-date'
      >
        {format(date, rowDateFormat)}
      </Typography>
    </div>
  );
}